/**
 * Confidence ladder ported from the Phase-1 assistant (docs/phase1-reference.md §5).
 * The numeric retrieval thresholds do not carry over — the three levels, the honest
 * low-confidence copy, and "low confidence enqueues the question for a human" do.
 */
export const CONFIDENCE_LEVELS = ["high", "medium", "low"] as const;

export type ConfidenceLevel = (typeof CONFIDENCE_LEVELS)[number];

/** Where the answer came from — self-reported by the model via the `report_grounding` tool. */
export const GROUNDING_KINDS = ["tools", "knowledge", "uncertain"] as const;

export type GroundingKind = (typeof GROUNDING_KINDS)[number];

/** Verbatim Phase-1 UI labels. */
export const CONFIDENCE_LABELS_ET: Record<ConfidenceLevel, string> = {
  high: "Kindel vaste",
  medium: "Võimalik vaste",
  low: "Vajab inimese vastust",
};

export interface Grounding {
  confidence: ConfidenceLevel;
  kind: GroundingKind;
  /** True when the answer is shown with the "needs review" banner and queued for a human. */
  needsReview: boolean;
  /** Short Estonian note from the model on what is still unverified. */
  note?: string;
}
